export const FEATURE_TOGGLES = Object.freeze({
  // Centralized solution
  CEN_SOL_V2: 'censolv2',
  LITESIM: 'litesim',
} as const);
